export default __webpack_public_path__ + "static/media/Home_principal.60de2fe6.png";